var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83331 10H3.24998M7.49998 4.33333H4.66665C4.29092 4.33333 3.93059 4.48259 3.66491 4.74827C3.39923 5.01394 3.24998 5.37428 3.24998 5.75V14.25C3.24998 14.6257 3.39923 14.9861 3.66491 15.2517C3.93059 15.5174 4.29092 15.6667 4.66665 15.6667H7.49998M11.75 10H20.25M24.5 4.33333H27.3333C27.709 4.33333 28.0694 4.48259 28.335 4.74827C28.6007 5.01394 28.75 5.37428 28.75 5.75V14.25C28.75 14.6257 28.6007 14.9861 28.335 15.2517C28.0694 15.5174 27.709 15.6667 27.3333 15.6667H24.5M30.1666 10H28.75M7.49998 2.91667V17.0833C7.49998 17.4591 7.64923 17.8194 7.91491 18.0851C8.18059 18.3507 8.54092 18.5 8.91665 18.5H10.3333C10.709 18.5 11.0694 18.3507 11.335 18.0851C11.6007 17.8194 11.75 17.4591 11.75 17.0833V2.91667C11.75 2.54094 11.6007 2.18061 11.335 1.91493C11.0694 1.64926 10.709 1.5 10.3333 1.5H8.91665C8.54092 1.5 8.18059 1.64926 7.91491 1.91493C7.64923 2.18061 7.49998 2.54094 7.49998 2.91667ZM20.25 2.91667V17.0833C20.25 17.4591 20.3992 17.8194 20.6649 18.0851C20.9306 18.3507 21.2909 18.5 21.6666 18.5H23.0833C23.459 18.5 23.8194 18.3507 24.085 18.0851C24.3507 17.8194 24.5 17.4591 24.5 17.0833V2.91667C24.5 2.54094 24.3507 2.18061 24.085 1.91493C23.8194 1.64926 23.459 1.5 23.0833 1.5H21.6666C21.2909 1.5 20.9306 1.64926 20.6649 1.91493C20.3992 2.18061 20.25 2.54094 20.25 2.91667Z",
    stroke: "#66c2ed",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.a9c6f05d68e3d0fecbc98b046eea0464.svg";
export { ForwardRef as ReactComponent };